fragment Tag on Tag {
    id
    label
}
